export type RegisterStage =
  (typeof REGISTER_STAGE)[keyof typeof REGISTER_STAGE];

export const REGISTER_STAGE = {
  MAIL_AUTH: 'mail_auth',
  PROFILE: 'profile',
  EDUCATION: 'education',
  SKILL: 'skill',
  IT_SKILL: 'it_skill',
  WISH: 'wish',
  FOLLOW: 'follow',
  CONFIRM: 'confirm',
} as const;

export const REGISTER_STAGE_LIST = [
  REGISTER_STAGE.MAIL_AUTH,
  REGISTER_STAGE.PROFILE,
  REGISTER_STAGE.EDUCATION,
  REGISTER_STAGE.SKILL,
  REGISTER_STAGE.IT_SKILL,
  REGISTER_STAGE.WISH,
  REGISTER_STAGE.FOLLOW,
  REGISTER_STAGE.CONFIRM,
] as const;

// DBの"hashtag_categories"テーブルにマスタあり

export type HashtagCategory = keyof typeof hashtagCategoryDictionary;

export const hashtagCategoryDictionary = {
  operation: 1,
  company: 2,
  industryCategory: 3,
  industry: 4,
  graduateYear: 5,
  department: 6,
  selection: 7,
  direction: 8,
  offer: 9,
  contentType: 10,
  general: 11,
  technology: 12,
};

export const hashtagCategoryDictionaryReverse: Record<number, HashtagCategory> =
  {
    1: 'operation',
    2: 'company',
    3: 'industryCategory',
    4: 'industry',
    5: 'graduateYear',
    6: 'department',
    7: 'selection',
    8: 'direction',
    9: 'offer',
    10: 'contentType',
    11: 'general',
    12: 'technology',
  };

export const GROUPED_HASHTAGS_KEY = {
  DATABASE: 'database',
  DEVELOPMENT_EXPERIENCE: 'developmentExperience',
  PROGRAMMING_LANGUAGE: 'programmingLanguage',
  LIBRARY_FRAMEWORK: 'libraryFramework',
  DEV_EXP_SUMMARY: 'devExpSummary',
  DEV_EXP_CATEGORY: 'devExpCategory',
} as const;

export type GroupedHashtagsKeyType =
  (typeof GROUPED_HASHTAGS_KEY)[keyof typeof GROUPED_HASHTAGS_KEY];

export const EMAIL_INPUT_ERROR_TYPE = {
  FORMAT_ERROR: 'formatError',
  SERVER_ERROR: 'serverError',
  LENGTH_ERROR: 'lengthError',
  CONFLICT_ERROR: 'conflictError',
  MICROSOFT_ERROR: 'microsoftError',
  UNIVERSITY_ERROR: 'universityError',
  NONE: '',
} as const;

export type EmailInputErrorType =
  (typeof EMAIL_INPUT_ERROR_TYPE)[keyof typeof EMAIL_INPUT_ERROR_TYPE];

// 大学認証完了後の遷移先で完了モーダルを出すためのパラメータ。
export const AC_VERIFIED_QUERY_PARAM = 'ac_verified';
